export const ADD_BANNER = 'ADD_BANNER'
export const REMOVE_BANNER = 'REMOVE_BANNER'

export const DISMISSED_BANNER_LOCAL_STORAGE_KEY = 'dismissedBanner-'
